<script lang="ts">
	import { Heading, P } from "flowbite-svelte-v1";
	import type { Snippet } from "svelte";

	interface Props {
		title: string;
		content?: Snippet;
		children?: Snippet;
		// The children box's heading. Defaults to "Appearance" (the poll look); pass "" to hide it when the
		// caller's own title already names the group.
		appearanceLabel?: string;
	}

	let { title, content, children, appearanceLabel = "Appearance" }: Props = $props();
</script>

<div class="flex w-full flex-col gap-5">
	<Heading tag="h2" class="text-sm font-medium">{title}</Heading>
	{#if content}
		<div class="flex w-full flex-col gap-2 rounded-lg border p-3">
			{@render content()}
		</div>
	{/if}
	{#if children}
		<div class="flex flex-col gap-4 rounded-lg border p-3">
			{#if appearanceLabel}
				<P class="text-sm font-semibold">{appearanceLabel}</P>
			{/if}
			{@render children()}
		</div>
	{/if}
</div>
